import gql from 'graphql-tag';

export const GET_COMPLYCUBE_WATCHLIST = gql`
    query getComplycubeWatchlist($input: GetOnfidoWatchlistInput!) {
      getComplycubeWatchlist(input: $input)
    }
`;
